import { User } from '../../user/user';

export const RESETPASSWORD: User[] = [];
